// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__-TAI-","rootSmall":"AddTileButton_rootSmall__rVSbv"};